let userDetails = {
    name: 'Matteo',
    group: 1
  }

  export default userDetails;